module.exports = __webpack_public_path__ + "static/media/initiated.eefc59fe.svg";